export default "__VITE_ASSET__DjnUfMVQ__"